/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'window',
    'jquery',
    'pip-model',
    'pip-events',
    'thd-overlay',
    'mustache',
    'workwear-fit-rating',
    'workwear-size-chart-data'
  ],
  function(
    window,
    $,
    pip,
    pipEvents,
    thdOverlay,
    Mustache,
    fitRating,
    sizeChartData
  ){

  var ATTRIBUTE_HOOKS_CLOTHING = ['size','chest size'];
  var ATTRIBUTE_HOOKS_FOOTWEAR = ['shoe size'];
  var view = {
    overlayConfig: {
      speed: '500ms',
      useContent: true,
      channel: null,
      mobileDirection: 'left',
      header: true,
      title: null,
      htmlNode: null,
      initialHeight: 300,
      closeButton: true
    },
    selectors: {
      triggerSizeChart: '#link_fitChart a',
      clothingSizeChart: '.clothing-size-chart',
      mobileOverlayClose: '.clothing-size-chart .card__overlay-go-back',
      tabs:{
        tabElem: '.overlay-tabs > .overlay-tabs__item',
        parent: '.overlay-tabs-container',
        content: '.overlay-tab-content',
        section: '.overlay-tab-content__section'
      }
    },
    classes:{
      activeContentClass: 'overlay-tab-content__active',
      activeTabClass: 'overlay-tabs__active',
    },
    templates: {
      sizeChart: $('#ssku__workwear-size-chart').text(),
      linkSizeChart: $('#ssku__workwear-size-chart-link').text()
    },
    render: {
      sizeCharts: function renderSizeCharts() {
        return Mustache.render(view.templates.sizeChart, viewModel.data);
      }
    },
    initSizeChartOverlay: function initSizeChartOverlay(e){
      e.preventDefault();
      view.overlayContent = view.bindOverlayTabClicks( view.render.sizeCharts() );
      view.overlayConfig.title = viewModel.data.title;
      view.overlayConfig.channel = pip.platformForCart;
      view.openSizeChartOverlay();
    },
    openSizeChartOverlay: function openSizeChartOverlay(){

      view.overlayContent.appendTo(window.document.body);
      view.overlayConfig.htmlNode = view.overlayContent[0];
      var overlay = new thdOverlay(view.overlayConfig);

      overlay.open();

      $(window.document).off('.close-overlay');

      /* custom close button for overlay */
      if(pip.platformForCart === 'mobile') {
        $(overlay.el).find(view.selectors.mobileOverlayClose).on('click.close-overlay', function (e) {
          e.preventDefault();
          overlay.close();
        });
      }

      /* FIX for overlay close button not working when overlay option header = true */
      $(overlay.header.nextElementSibling).on('click.close-overlay', function(e){
        e.preventDefault();
        overlay.close();
      });

    },
    bindOverlayTabClicks: function bindOverlayTabClicks(overlayContent){
      $(window.document).off('.select-overlay-tab');
      var overlayContent = $( overlayContent );

      overlayContent.find(view.selectors.tabs.tabElem).on('click.select-overlay-tab', function(e){
        overlayContent.find(view.selectors.tabs.tabElem).removeClass(view.classes.activeTabClass);
        var thisTab = $(e.target).addClass(view.classes.activeTabClass);
        var section = overlayContent.find(view.selectors.tabs.section).removeClass(view.classes.activeContentClass);
        section.eq( thisTab.index() ).addClass(view.classes.activeContentClass);
      });

      return overlayContent;
    },
    initEventListeners: function initEventListeners() {
        $(window.document).on('click.sskuSizeChart', view.selectors.triggerSizeChart, view.initSizeChartOverlay);
    }
  };

  var viewModel = {
    productType: null,
    isWorkwear: false,
    hasSizeChart: false,
    brand: null,
    brandTemplates:[],
    activeTemplate: 'standard',
    data: null,
    set: {
      workwear: function workwear(isWorkwear){
        viewModel.isWorkwear = isWorkwear;
      },
      sizeChart: function sizeChart(hasSizeChart){
        viewModel.hasSizeChart = hasSizeChart;
      },
      productType: function productType(productType){
        viewModel.productType = productType;
      },
      brand: function brand(brand) {
        viewModel.brand = brand;
      },
      activeTemplate: function activeTemplate(template){
        viewModel.activeTemplate = template;
      },
      data: function data(data){
        viewModel.data = data;
      }
    },
    brandLookup: function brandLookup(){
      if (pip.products && pip.products.primary &&
          pip.products.primary.data &&
          pip.products.primary.data.info &&
          pip.products.primary.data.info.brandName) {
        return pip.products.primary.data.info.brandName;
      }
      return '';
    },
    chooseTemplate: function chooseTemplate(brand){
      /* check if template exists for brand (and brand is not null) - otherwise return standard template */
      return ((brand
        && model.data[viewModel.productType]
        && model.data[viewModel.productType][brand]) ? brand : 'standard');
    },
    initViewModel: function initViewModel() {
      var brand = viewModel.brandLookup();
      var brandTemplate = viewModel.chooseTemplate( brand.toLowerCase() );
      viewModel.set.brand( brand );
      viewModel.set.activeTemplate( brandTemplate );
      viewModel.set.data( model.data[viewModel.productType][brandTemplate] );
    }
  }

  var model = {
    data: {},
    isWorkwear: function isWorkwear() {
      var subClass;
      var department;
      if (pip.products && pip.products.primary &&
        pip.products.primary.data && pip.products.primary.data.info &&
        pip.products.primary.data.info.subClassNumber &&
        pip.products.primary.data.info.productDepartment) {
        subClass = pip.products.primary.data.info.subClassNumber;
        department = pip.products.primary.data.info.productDepartment;
      }
      var isClothing = (department === '25' && (subClass === '5' || subClass === '13'));
      var isFootwear = (department === '24' && subClass === '9');
      return isClothing || isFootwear;
    },
    sizeChartQualified: function sizeChartQualified(attributes) {
      /* Iterates attributes in search of below `attribute hooks` and determines if a size chart
         should be linked and available, also classifies product into either clothing or footwear.
         Sets viewModel flags and returns true if the product is workwear.
      */
      var SIZE_TERMS = ['extra small','small','medium','large','extra large','2x large'];
      var sizeChartFlag = false;

      attributes.forEach(function(attribute){

        var attributeName = attribute.attributeName.toLowerCase();

        if (ATTRIBUTE_HOOKS_CLOTHING.indexOf(attributeName) > -1) {

          var hasSizes = attribute.attributeValues.map(function(attribute) {
            return attribute.value.toLowerCase();
          }).some(function (value) {
            return SIZE_TERMS.indexOf(value) > -1;
          });

          viewModel.set.sizeChart(hasSizes);
          viewModel.set.productType('clothing');
          sizeChartFlag = true;

        } else if (ATTRIBUTE_HOOKS_FOOTWEAR.indexOf(attributeName) > -1) {
          viewModel.set.sizeChart(true);
          viewModel.set.productType('footwear');
          sizeChartFlag = true;
        }
      });

      return sizeChartFlag;
    },
    init: function init(attributes) {
      model.data = sizeChartData;
      model.attributes = attributes;
      return model.sizeChartQualified(attributes);
    }
  }

  return {
    init: function init(attributes) {

      if (model.isWorkwear()) {

        viewModel.set.workwear(true);

        fitRating.init();

        model.init(attributes);

        if(viewModel.hasSizeChart) {
          viewModel.initViewModel();

          pipEvents.ssku.sskuMetaDataLoaded.on('ssku.metaDataLoaded', function () {
            view.initEventListeners();
          });
        }
      }

    },
    view: view,
    viewModel: viewModel,
    model: model,
    fitRating: fitRating,
    getAttributeInjector: function getAttributeInjector(){
      /* Can be called by pip-ssku to get any strings that need to
         be injected next to the attribute name/value in super sku.
      */
      var attributeInjector = {}
      if(viewModel.isWorkwear && viewModel.hasSizeChart) {
        ATTRIBUTE_HOOKS_CLOTHING.forEach(function (attributeName) {
          attributeInjector[attributeName] = view.templates.linkSizeChart;
        });
        ATTRIBUTE_HOOKS_FOOTWEAR.forEach(function (attributeName) {
          attributeInjector[attributeName] = view.templates.linkSizeChart;
        });
      }
      return attributeInjector;
    }
  }

});

}.call(window));